// import { confirmAlert } from "react-confirm-alert";

export const logApiFail = (path, request, response) => {
  // eslint-disable-next-line no-undef
  Rollbar.warning("API FAILURE: " + path, { request: request, response: response });
};

export const logOpenEdgeRequest = (endpoint, requestData) => {
  // eslint-disable-next-line no-undef
  Rollbar.info("OPENEDGE REQUEST: " + endpoint, { 
    endpoint: endpoint, 
    request: sanitizePaymentData(requestData),
    timestamp: new Date().toISOString()
  });
};

export const logOpenEdgeResponse = (endpoint, responseData, success = true) => {
  const level = success ? "info" : "warning";
  // eslint-disable-next-line no-undef
  Rollbar[level]("OPENEDGE RESPONSE: " + endpoint, { 
    endpoint: endpoint, 
    response: sanitizePaymentData(responseData),
    success: success,
    timestamp: new Date().toISOString()
  });
};

export const logSSMRequest = (endpoint, requestData) => {
  // eslint-disable-next-line no-undef
  Rollbar.info("SSM API REQUEST: " + endpoint, { 
    endpoint: endpoint, 
    request: sanitizePaymentData(requestData),
    timestamp: new Date().toISOString()
  });
};

export const logSSMResponse = (endpoint, responseData, success = true) => {
  const level = success ? "info" : "warning";
  // eslint-disable-next-line no-undef
  Rollbar[level]("SSM API RESPONSE: " + endpoint, { 
    endpoint: endpoint, 
    response: sanitizePaymentData(responseData),
    success: success,
    timestamp: new Date().toISOString()
  });
};

export const logRCMRequest = (method, requestData) => {
  // eslint-disable-next-line no-undef
  Rollbar.info("RCM REQUEST: " + method, { 
    method: method, 
    request: sanitizePaymentData(requestData),
    timestamp: new Date().toISOString()
  });
};

export const logRCMResponse = (method, responseData, success = true) => {
  const level = success ? "info" : "warning";
  // eslint-disable-next-line no-undef
  Rollbar[level]("RCM RESPONSE: " + method, { 
    method: method, 
    response: sanitizePaymentData(responseData),
    success: success,
    timestamp: new Date().toISOString()
  });
};

const sanitizePaymentData = (data) => {
  if (!data) return data;
  
  let sanitized = JSON.parse(JSON.stringify(data));
  
  const sensitiveFields = [
    'cc_no', 'ACCOUNT', 'accountNumber', 'account_number',
    'routingNumber', 'routing_number', 'ACHAccountNumber', 'ACHRoutingNumber',
    'cvv', 'CVV', 'cvv2', 'CVV2',
    'password', 'token', 'ALIAS',
    'strACHAccountNumber', 'strACHRoutingNumber'
  ];
  
  const maskSensitiveData = (obj) => {
    if (typeof obj !== 'object' || obj === null) return obj;
    
    for (let key in obj) {
      if (sensitiveFields.some(field => key.toLowerCase().includes(field.toLowerCase()))) {
        if (typeof obj[key] === 'string' && obj[key].length > 4) {
          obj[key] = '****' + obj[key].slice(-4);
        } else {
          obj[key] = '****';
        }
      } else if (typeof obj[key] === 'object') {
        maskSensitiveData(obj[key]);
      }
    }
    return obj;
  };
  
  return maskSensitiveData(sanitized);
};
